export default __webpack_public_path__ + "static/media/Update-Address.fc12d4b4.jpg";